
















import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import VueScrollTo from "vue-scrollto";
import LinePreload from "@/components/common/preloaders/LinePreload.vue";

@Component({
  name: "CategoryList",
  components: {
    LinePreload
  },
  computed: mapGetters("shops", ["getCategoryList"])
})
export default class CategoryList extends Vue {
  onClickLink(el) {
    this.$router.push({ path: `/shops${el}` });
  }
}
